import { render, staticRenderFns } from "./cuForm.vue?vue&type=template&id=de958840&scoped=true"
import script from "./cuForm.vue?vue&type=script&lang=js"
export * from "./cuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de958840",
  null
  
)

export default component.exports